import React from "react";
import { useRouter } from "next/router";
import ReactGA_UA from "react-ga";
import ReactGA_4 from "react-ga4";
import dynamic from "next/dynamic";
import FrontPage from "@components/Pages/FrontPage/FrontPage";
import LaufidLoader from "@components/LaufidLoader/LaufidLoader";

const Page = dynamic(() => import("@components/Layout/page"), {
    loading: () => <LaufidLoader />,
});

function laufidPage() {
    const router = useRouter();
    React.useEffect(() => {
        ReactGA_UA.pageview(router.asPath);
        ReactGA_4.send({ hitType: "pageview", page: router.asPath });
    }, []);
    return (
        <Page fluid>
            <FrontPage />
        </Page>
    );
}

export default laufidPage;

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
